import { render, staticRenderFns } from "./status-b.vue?vue&type=template&id=61b2a7b2&"
import script from "./status-b.vue?vue&type=script&lang=js&"
export * from "./status-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports